import React from 'react';
import { Box, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const RSVPStatusChart = ({ confirmedGuests, pendingGuests, declineCount }) => {
    const data = {
        labels: ['RSVP Status'],
        datasets: [
            {
                label: 'Confirmed Guests',

                backgroundColor: 'rgba(102, 164, 104, 0.6)',
                borderColor: 'rgba(102, 164, 104, 0.6)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(102, 164, 104, 0.6)',
                hoverBorderColor: 'rgba(102, 164, 104, 0.6)',
                data: [confirmedGuests, confirmedGuests],
            },
            {
                label: 'Pending Guests',
                backgroundColor: 'rgba(188, 104, 60, 0.6)',
                borderColor: 'rgba(188, 104, 60, 0.6)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(188, 104, 60, 0.6)',
                hoverBorderColor: 'rgba(188, 104, 60, 0.6)',
                data: [pendingGuests, pendingGuests],
            },
            {
                label: 'Declined Guests',
                backgroundColor: 'rgba(155, 51, 51, 0.6)',
                borderColor: 'rgba(155, 51, 51, 0.6)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(155, 51, 51, 0.6)',
                hoverBorderColor: 'rgba(155, 51, 51, 0.6)',
                data: [declineCount, declineCount],
            },
        ],
    };

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <Box p={4}>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
                <Box bg="gray.100" p={4} borderRadius="md">
                    <Text fontSize="lg" mb={2} as='b'>RSVP Status</Text>
                    <Stack direction="column">
                        <Text>
                            Confirmed: {confirmedGuests}
                        </Text>
                        <Text>
                            Declined: {declineCount}
                        </Text>
                        <Text>
                            Pending: {pendingGuests}
                        </Text>

                    </Stack>
                    <Bar data={data} options={options} />
                </Box>
            </SimpleGrid>
        </Box>
    );
};

export default RSVPStatusChart;
